import { api } from "@/lib/api";

const MAX_URL_ORDER = 1500;

// Ekrandaki sıralamayı export'a taşır. Liste uzunsa adres satırı yerine
// sunucuda kısa bir anahtar (tok:...) oluşturulur; böylece URL limiti aşılmaz.
export const exportOrder = async (ids) => {
  const list = (ids || []).map((x) => String(x ?? "")).filter(Boolean);
  const joined = list.join(",");
  if (joined.length <= MAX_URL_ORDER) return joined;
  try {
    const { data } = await api.post("/exports/order", { ids: list });
    return `tok:${data.token}`;
  } catch {
    return "";
  }
};
